import React from "react";
import { Link } from "react-router-dom";

const categories = [
    { name: "Skin Care", image: "/images/categories/5.png", url: "/category/skin-care" },
    { name: "Hair Care", image: "/images/categories/1.png", url: "/category/hair-care" },
    { name: "Body Care", image: "/images/categories/6.png", url: "/category/body-care" },
    { name: "Lip Care", image: "/images/categories/4.png", url: "/category/lip-care" },
    { name: "Eye Care", image: "/images/categories/2.png", url: "/category/eye-care" },
    { name: "Nose Care", image: "/images/categories/3.png", url: "/category/Nose-care" },
  ];
  

const ShopByCategory = () => {
  return (
    <section className="my-6 sm:my-12 px-2 sm:px-4 text-center">
      <h2 className="text-xl mb-2  sm:text-3xl font-bold sm:mb-8">Shop by Category</h2>
      <div className="grid grid-cols-6 gap-0.5 md:gap-4 justify-center items-center">
        {categories.map((category) => (
          <Link
            to={category.url}
            key={category.name}
            className="flex flex-col items-center hover:opacity-80"
          >
            <img
              src={category.image}
              alt={category.name}
              className="w-18 sm:w-28 sm:h-28 md:w-36 md:h-36 rounded-full object-cover sm:border-black border-2"
            />
            <p className="mt-1 sm:mt-2 sm:font-medium text-xs sm:text-base">
              {category.name}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ShopByCategory;
